import { render, staticRenderFns } from "./healthy.vue?vue&type=template&id=633725da&scoped=true"
import script from "./healthy.vue?vue&type=script&lang=js"
export * from "./healthy.vue?vue&type=script&lang=js"
import style0 from "./healthy.vue?vue&type=style&index=0&id=633725da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633725da",
  null
  
)

export default component.exports